/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {protectV2} from '../api'

export const useMutationProtectV2 = createReactQueryMutationHook('protectV2', protectV2)
